import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';

export const useVerifyChangeEmail = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: payload =>
      userService.verifyChangeEmailCode(payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.user.profile],
          });
          return { success: true, error: null };
        }
        return { success: false, error: data.message };
      }),
  });
};
